export default __webpack_public_path__ + "static/media/seller5.ae40df41.jpg";